import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation, faCircleInfo, faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

const ICONS = {
  warn: faTriangleExclamation,
  error: faCircleExclamation,
  high: faCircleInfo,
  info: faCircleInfo,
};

/**
 * Inline message (design Alert): warn (something blocks the task), high (consequence of a choice), error (an
 * operation failed) and info. Alerts that appear because of an action carry role="alert". Any button goes
 * below the alert, not inside it.
 */
export default function Alert({ tone = "info", title, role, children }) {
  return (
    <div className={`crm-rollo__alert crm-rollo__alert--${tone}`} role={role}>
      <FontAwesomeIcon icon={ICONS[tone] || faCircleInfo} className="crm-rollo__alert-ico" aria-hidden="true" />
      <div>
        <b>{title}</b>
        {children ? <div>{children}</div> : null}
      </div>
    </div>
  );
}
